export default "__VITE_ASSET__23020bc1__"